export function addDismissOnOutsidePointerDown({ rootEl, onDismiss }) {
  function onPointerDown(event) {
    if (!rootEl) return;
    if (rootEl.contains(event.target)) return;
    onDismiss?.();
  }

  function onIframePointerDown() {
    onDismiss?.();
  }

  const iframeWindows = Array.from(document.querySelectorAll('iframe.tox-edit-area__iframe'))
    .map((iframe) => iframe.contentWindow)
    .filter(Boolean);

  window.addEventListener('mousedown', onPointerDown);
  window.addEventListener('touchstart', onPointerDown);
  iframeWindows.forEach((win) => win.addEventListener('mousedown', onIframePointerDown));

  return () => {
    window.removeEventListener('mousedown', onPointerDown);
    window.removeEventListener('touchstart', onPointerDown);
    iframeWindows.forEach((win) => win.removeEventListener('mousedown', onIframePointerDown));
  };
}

export function addDismissOnEscape({ onDismiss, focusEl }) {
  function onKeyDown(event) {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    onDismiss?.();
    focusEl?.focus?.();
  }

  window.addEventListener('keydown', onKeyDown);
  return () => window.removeEventListener('keydown', onKeyDown);
}
